import type { ReactNode } from "react";

export function QuotesColumnHeader({ children }: { children: ReactNode }) {
  return (
    <div className="text-[18px] font-semibold text-content-muted">
      {children}
    </div>
  );
}
